import { useState } from "react";
import { Modal } from "antd";
import { X as ICON_X } from 'react-feather';
import { useLanguage } from "assets/languages";
import TextInputField from "components/textInput";
import Button from "components/button";
import Checkbox from "components/checkbox";
import API from "api";


interface Props {
  isVisible: boolean;
  letClose: (result: boolean) => void;
  brandToken: string;
  brandName: string;
  brandId: number;
  username: string;
  savedPhoneNumber?: string;
  userModelSuggestedAt: any;
  userId: number;
  mobile: string;
  userModelInstaUserId: string;
  showModal?: any;
  onSavePhoneNumber?: (phone: string, shouldSave: boolean) => void;
}


const ModalRequestRecruitingCampaignApplicationBrand = (props: Props) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.pages.campaigns,
  };

  // Always start with '010-' if no saved number
  const [phoneNumber, setPhoneNumber] = useState(props.savedPhoneNumber || '010-');
  const [shouldSavePhone, setShouldSavePhone] = useState(true);

  const formatPhoneNumber = (value: string) => {
    // Always ensure it starts with 010-
    if (!value.startsWith('010')) {
      return '010-';
    }
    
    const numbers = value.replace(/\D/g, '');
    
    // Must start with 010
    if (!numbers.startsWith('010')) {
      return '010-';
    }
    
    if (numbers.length <= 3) return '010-';
    if (numbers.length <= 7) return `010-${numbers.slice(3)}`;
    return `010-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
  };

  const handlePhoneChange = (value: string) => {
    // Don't allow removal of '010-' prefix
    if (value.length < 4) {
      setPhoneNumber('010-');
      return;
    }
    
    const formatted = formatPhoneNumber(value);
    if (formatted.replace(/-/g, '').length <= 11) {
      setPhoneNumber(formatted);
    }
  };

  // Valid when we have 11 digits total (010 + 8 more)
  const isPhoneValid = phoneNumber.replace(/-/g, '').length === 11;

  const onSubmit = async () => {
    const phoneDigits = phoneNumber.replace(/-/g, '');
    if (phoneDigits.length !== 11) return;
    
    try {
      await API.Brand.storeBrandRequestRecruitingCampaignApplication({
        brandToken: props.brandToken,
        userId: props.userId,
        phoneNumber: phoneNumber,
        userModelInstaUserId: props.userModelInstaUserId,
        userModelSuggestedAt: props.userModelSuggestedAt,
      });
      
      // Save phone number if checkbox is checked
      if (props.onSavePhoneNumber) {
        props.onSavePhoneNumber(phoneNumber, shouldSavePhone);
      }
      
      props.letClose(true);
    } catch (e) {
      props.showModal({
        hideCloseButton: true,
        text: e.message,
      });
    }
  }

  return (
    <Modal
      wrapClassName="py-4"
      className="rounded-antd-modal"
      centered={true}
      open={props.isVisible}
      onCancel={() => props.letClose(false)}
      footer={null}
      closable={false}
      zIndex={1090}
      width={480}
    >
      <div className="relative select-none">
        <div className="absolute top-[24px] right-[24px] cursor-pointer" onClick={() => props.letClose(false)}>
          <ICON_X size={24} />
        </div>
        <div className="py-[50px] flex flex-col bg-white rounded-2xl">
          <div className="flex flex-row justify-between pl-[50px] pr-[30px]">
            <span className="font-bold text-[22px] text-black">
              {languageTexts.brand_request_recruiting_campaign_application_modal_title}
            </span>
          </div>
          <div className="mt-[40px] px-[50px] text-[15px] whitespace-pre-wrap leading-5">
            {languageTexts.brand_request_recruiting_campaign_application_modal_text(props.username)}
          </div>
          <div className="mt-[35px] px-[50px]">
            <div className="text-[15px] mb-[8px] font-bold">{languageTexts?.brand_request_recruiting_campaign_application_modal_phone_label}</div>
            <TextInputField
              bordered
              placeholder="010-0000-0000"
              value={phoneNumber}
              onChangeText={handlePhoneChange}
              numbersOnly
              maxLength={13}
            />
          </div>
          <div className="mt-[10px] px-[50px]">
            <Checkbox
              text="저장해두기"
              checked={shouldSavePhone}
              onClick={(isChecked) => setShouldSavePhone(isChecked)}
            />
          </div>
          <div className="mt-[18px] px-[50px]">
            <div className={!isPhoneValid ? 'opacity-50 pointer-events-none' : ''}>
              <Button
                text={languageTexts?.done}
                onClick={onSubmit}
                textColor="WHITE"
                borderColor="BLACK"
                buttonColor="BLACK"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}


export default ModalRequestRecruitingCampaignApplicationBrand;
